/** A small stroke icon set (24×24 grid, currentColor), so icons follow the theme. */
const PATHS = {
  play: "M7 4.5v15l12.5-7.5z",
  stop: "M6.5 6.5h11v11h-11z",
  sliders: "M4 7h9M17 7h3M4 17h3M11 17h9M15 5v4M9 15v4",
  share: "M12 15V3.5M7.5 8 12 3.5 16.5 8M5 12.5V20h14v-7.5",
  sun: "M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zM12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8",
  moon: "M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z",
  monitor: "M3.5 4.5h17v11h-17zM8.5 20h7M12 15.5V20",
  filePlus: "M14 3.5H6.5v17h11V7zM14 3.5V7h3.5M12 10.5v6M9 13.5h6",
  upload: "M12 15V4M7.5 8.5 12 4l4.5 4.5M4.5 15v5h15v-5",
  download: "M12 4v11M7.5 10.5 12 15l4.5-4.5M4.5 15v5h15v-5",
  file: "M14 3.5H6.5v17h11V7zM14 3.5V7h3.5",
  folder: "M3.5 6.5h6l2 2h9v10.5h-17z",
  chevron: "M9.5 6.5 15 12l-5.5 5.5",
  close: "M6.5 6.5l11 11M17.5 6.5l-11 11",
  terminal: "M5 7.5 9.5 12 5 16.5M12 17h7",
  users:
    "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 4.3a3.5 3.5 0 0 1 0 6.4M17 14.2c2.4.7 4 2.9 4 5.8",
  chat: "M4.5 5.5h15v10h-8l-4.5 4v-4h-2.5z",
  plug: "M9 3.5V8M15 3.5V8M6.5 8h11v3a5.5 5.5 0 0 1-11 0zM12 16.5v4",
  pencil: "M15.5 4.5l4 4L9 19H5v-4z",
  trash: "M4.5 7h15M9.5 4h5M7 7l1 13h8l1-13M10.5 11v5.5M13.5 11v5.5",
  folderPlus: "M3.5 6.5h6l2 2h9v10.5h-17zM12 11v6M9 14h6",
  folderUp: "M3.5 6.5h6l2 2h9v10.5h-17zM12 17v-5.5M9.5 14 12 11.5l2.5 2.5",
  archive: "M3.5 5h17v4h-17zM5 9v10h14V9M10 13h4",
  search: "M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM15.5 15.5 20 20",
  files: "M8 3.5h7l4 4V17H8zM15 3.5v4h4M5 7v13.5h10",
  github:
    "M9 19c-4.3 1.4-4.3-2.5-6-3m12 5v-3.5c0-1 .1-1.4-.5-2 2.8-.3 5.5-1.4 5.5-6a4.6 4.6 0 0 0-1.3-3.2 4.2 4.2 0 0 0-.1-3.2s-1.1-.3-3.5 1.3a12.3 12.3 0 0 0-6.2 0C6.5 2.8 5.4 3.1 5.4 3.1a4.2 4.2 0 0 0-.1 3.2A4.6 4.6 0 0 0 4 9.5c0 4.6 2.7 5.7 5.5 6-.6.6-.6 1.2-.5 2V21",
  warning: "M12 3.5 21 19.5H3zM12 10v4.5M12 17.2v.3",
  pin: "M9 4.5h6M10 4.5v5l-3 3.5h10l-3-3.5v-5M12 13v6.5",
  remote: "M10 5 4.5 10.5 10 16M14 8l5.5 5.5L14 19",
  gear: "M18.7 10.0L21.1 10.6L21.1 13.4L18.7 14.0L18.1 15.4L19.4 17.4L17.4 19.4L15.4 18.1L14.0 18.7L13.4 21.1L10.6 21.1L10.0 18.7L8.6 18.1L6.6 19.4L4.6 17.4L5.9 15.4L5.3 14.0L2.9 13.4L2.9 10.6L5.3 10.0L5.9 8.6L4.6 6.6L6.6 4.6L8.6 5.9L10.0 5.3L10.6 2.9L13.4 2.9L14.0 5.3L15.4 5.9L17.4 4.6L19.4 6.6L18.1 8.6zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 16 }: { name: IconName; size?: number }) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} fill={name === "play" ? "currentColor" : "none"} />
    </svg>
  );
}

/**
 * The codescreen mark: a code prompt and a collaborator's caret, framed like a screen. Fixed
 * colors (the same tile in both themes), as in public/favicon.svg.
 */
export function Logo({ size = 22 }: { size?: number }) {
  return (
    <svg className="logo" width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#0a0a0a" />
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="7.5"
        fill="none"
        stroke="#ffffff"
        strokeOpacity="0.1"
      />
      <g fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 12V7h5M20 7h5v5M25 20v5h-5M12 25H7v-5" stroke="#fafafa" />
        <path d="M11.5 12.5 15 16l-3.5 3.5" stroke="#fafafa" />
        <path d="M19.5 11.5v9" stroke="#cba6f7" />
      </g>
    </svg>
  );
}
